export class OfflineError extends Error {
  constructor(message = 'This action requires an internet connection') {
    super(message);
    this.name = 'OfflineError';
  }
}

export function isOnline(): boolean {
  if (typeof navigator !== 'undefined' && 'onLine' in navigator) {
    return navigator.onLine;
  }
  return true;
}

export function requireOnlineForImportExport(): void {
  if (!isOnline()) {
    throw new OfflineError('Import and export require an internet connection');
  }
}
